var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      directives: [
        { name: "drag", rawName: "v-drag" },
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      attrs: {
        title: "分配供应商",
        visible: _vm.dialogVisible,
        width: "888px",
        "append-to-body": true,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "before-close": _vm.cancel,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("BaseTable", {
            ref: "baseTable",
            attrs: {
              height: 380,
              tableData: _vm.tableData,
              isPager: false,
              selectRows: _vm.selectRows,
              border: true,
            },
            on: { handleSelectionChange: _vm.handleSelectionChange },
            scopedSlots: _vm._u([
              {
                key: "phoneNumber",
                fn: function (row) {
                  return _c("el-input", {
                    attrs: { placeholder: "请输入" },
                    on: {
                      input: function ($event) {
                        return _vm.handleInputChange(row, "phoneNumber")
                      },
                    },
                    model: {
                      value: row.scope.phoneNumber,
                      callback: function ($$v) {
                        _vm.$set(row.scope, "phoneNumber", $$v)
                      },
                      expression: "row.scope.phoneNumber",
                    },
                  })
                },
              },
              {
                key: "email",
                fn: function (row) {
                  return _c("el-input", {
                    attrs: { placeholder: "请输入" },
                    model: {
                      value: row.scope.email,
                      callback: function ($$v) {
                        _vm.$set(row.scope, "email", $$v)
                      },
                      expression: "row.scope.email",
                    },
                  })
                },
              },
              {
                key: "emailPassword",
                fn: function (row) {
                  return _c("el-input", {
                    attrs: { placeholder: "请输入" },
                    model: {
                      value: row.scope.emailPassword,
                      callback: function ($$v) {
                        _vm.$set(row.scope, "emailPassword", $$v)
                      },
                      expression: "row.scope.emailPassword",
                    },
                  })
                },
              },
              {
                key: "remark",
                fn: function (row) {
                  return _c("el-input", {
                    attrs: { placeholder: "请输入" },
                    model: {
                      value: row.scope.remark,
                      callback: function ($$v) {
                        _vm.$set(row.scope, "remark", $$v)
                      },
                      expression: "row.scope.remark",
                    },
                  })
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "footers flex_c_c",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "div",
            { staticClass: "cancel flex_c_c", on: { click: _vm.cancel } },
            [_vm._v("取消")]
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "debounce-click",
                  rawName: "v-debounce-click",
                  value: { value: _vm.ok, args: ["form"] },
                  expression: "{ value: ok, args: ['form'] }",
                },
              ],
              staticClass: "ok flex_c_c",
            },
            [_vm._v(" 确定 ")]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }